"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductImplementationSearchResponse = void 0;
const common_1 = require("../../common");
const models_1 = require("../models");
class ProductImplementationSearchResponse extends common_1.PaginatedResponse {
}
exports.ProductImplementationSearchResponse = ProductImplementationSearchResponse;
//# sourceMappingURL=product-implementation-search.response.js.map